module.exports = __webpack_public_path__ + "static/media/SSI.b68c2d69.jpg";